export const TIMETABLE = 'TIMETABLE'
// export const TIMETABLE_UPDATED = 'TIMETABLE_UPDATED'
export const TIMETABLE_ALL = 'TIMETABLE_ALL'
// export const TIMETABLE_GENERATE = 'timetableGenerate'
export const TIMETABLE_GENERATE_UPDATED = 'TIMETABLE_GENERATE_UPDATED'
export const TIMETABLE_UPDATE_STATUS = 'TIMETABLE_UPDATE_STATUS'
export const TIMETABLE_HOURS_REPORT = 'TIMETABLE_HOURS_REPORT'
